import { IFamily } from '@gn-audio/core/api/product-catalogue/models/family';
import { Component, Input } from 'angular-ts-decorators';

import template from './product-comparison-product.component.html';

@Component({
  selector: 'productComparisonProduct',
  template,
})
export class ProductComparisonProductComponent {
  @Input() public product?: IFamily;
  @Input() public hideProductName = false;
  @Input() public hideProductPrice = false;
}
